export default "__VITE_ASSET__c934a7ab__"